module.exports = __webpack_public_path__ + "static/media/teacher5.a5479891.svg";